//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";


// custom pages
import { styles } from "./styles";
import screen from "apis/screen/screen";
import role from "apis/role/role";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from '@material-ui/lab/Autocomplete';
import useDebounce from 'helpers/useDebounce';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"
import { blockInvalidChar } from 'helpers/blockInvalidChar';

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);


export default function View(props) {
  const { state, dispatch } = useContext(Context);
  const [shiptoSearch, setShiptoSearch] = useState('');
  const shiptoSearchBounceValues = useDebounce(shiptoSearch);
  // const { updateScreen } = screen();
  const { updateRole, screenviewdetail,getuser } = role();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const { t, i18n } = useTranslation();
  
  const [states, setstates] = useState({
    Rolename: "",
    screenPath: "",
    isActive: true,
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
    roles: [],
    screen:[],
    viewdetails:[],
    shiptoSearch: '',
    shiptoLoading: false,
    shiptoList: [],
    isCdrAdmin: null
  });

  const {
    Rolename,
    screenPath,
    isActive,
    data,
    edittedData,
    isEdit,
    loading,
    roles,
    isCdrAdmin
    // viewdetails,
  } = states;
  console.log(data)
  // const [viewdetails, setviewdetails] = useState([])
  

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
    handleGet()
    
  }, []);

  

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      Rolename: dataObj?.role_name,      
      isActive: dataObj?.is_active,
      isCdrAdmin: dataObj?.is_cdr_admin,
      // initialRoles: dataObj.screen.map(i => {
      //   if (dataObj?.screenMapping.find(j => j.screen_id == i.screen_id) != null) {
      //     return {
      //       screen_id: i.screen_id,
      //       screen_name: i.screen_name,
      //       is_active: true
      //     }
      //   } else {
      //     return {
      //       screen_id: i.screen_id,
      //       screen_name: i.screen_name,
      //       is_active: false
      //     }
      //   }
      // }),
      // screen: dataObj.screen.map(i => {
      //   if (dataObj?.screenMapping.find(j => j.screen_id == i.screen_id) != null) {
      //     return {
      //       screen_id: i.screen_id,
      //       screen_name: i.screen_name,
      //       is_active: true
      //     }
      //   } else {
      //     return {
      //       screen_id: i.screen_id,
      //       screen_name: i.screen_name,
      //       is_active: false
      //     }
      //   }
      // }),
     });
  };

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "SCREEN", "VIEW"],
    });
  }, []);

  const handleGet = async () => {
    try {
      let id = location?.state?.data?.role_id;

      let values = {      
        id:id
      };
      dispatch({ type: "SET_LOADING", payload: true });
        let res = await  screenviewdetail(values);
      if (res) {
        setStates({viewdetails:res?.data});
        // setDataClone(res?.data[0]);
        // setCount(res?.count);
        // setBalance(res?.currentBalance)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdateScreen = async () => {
    try {      
      let obj = {
        roleId: data?.role_id,
        isActive,
        screenEdited: edittedData?.screenEdited
      }
     
      let res = await updateRole(obj);
      if(res.message == "Update successful") {
        toast.success('Updated Successfully...')
        handleGet()
        setStates({ loading: false });
        setStates({ isEdit: false, edittedData: {} });
      } else {
        toast.error('Something went wrong...')
        setStates({ loading: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>          
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {'Edit'}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
      <Grid item xs={8}>
          {/* <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Role ID'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                <span className={classes.label}>{data?.role_id}</span>
              }
            </Grid>
          </Grid> */}
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Role Name'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {/* {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={Rolename}
                    onChange={(e) => {
                      setStates({
                        Rolename: e.target.value,
                        edittedData: {
                          ...edittedData,
                          Rolename: e.target.value,
                        },
                      });
                    }}
                  /> */}
                <span className={classes.label}>{Rolename}</span>
              
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={8}>
          <Grid container spacing={0}> */}
            {/* <Grid item xs={4}>
              <strong className={classes.label}>{'Screen Path'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={screenPath}
                    onChange={(e) => {
                      setStates({
                        screenPath: e.target.value,
                        edittedData: {
                          ...edittedData,
                          screenPath: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{screenPath}</span>
              } */}
            {/* </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Status'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    id={"Is Active"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={isActive}
                    onChange={(e) => {
                      setStates({
                        isActive: e.target.value,
                        edittedData: {
                          ...edittedData,
                          isActive: e.target.value,
                        },
                      });
                    }}
                  >
                    {[
                      { label: "Active", value: true },
                      { label: "Inactive", value: false },
                    ].map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                ) : <span className={classes.label}>{isActive ? 'Active' : 'Inactive'}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Oneweb Role'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isCdrAdmin ? 'No' : 'Yes'}              
            </Grid>
          </Grid>
        </Grid>           */}
        
        <Grid container spacing={2} item xs={12}>
          {/* <Grid item xs={4}>
            <strong className={classes.label}> {'Roles'} : </strong>
          </Grid> */}
          <Grid item xs={4}>
            {/* <FormGroup>{
              screen?.slice(0, 6)?.map(i => {
                return <FormControlLabel
                  key={i.screen_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.is_active}
                      onChange={(e) => {
                        let arr = [...screen];
                        let index = arr.findIndex(k => k.screen_id == i.screen_id);
                        if (e.target.checked) {
                          arr[index].is_active = true
                        } else {
                          arr[index].is_active = false
                        }
                        setStates({ ...states, screen: arr })
                      }}
                    />
                  }
                  label={i.screen_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup> */}
              <strong className={classes.label}> {'Screens'} : </strong>
          </Grid> 
          <Grid container spacing={3} justifyContent="space-between" alignItems="flex-start"className={classes.gridContainer}  >
      {Array.from({ length: 4 }).map((_, columnIndex) => (
        <Grid item xs={3} key={columnIndex} sx={{ flexGrow: 1 }} className={classes.griditem}>
          {states?.viewdetails?.slice(columnIndex * Math.ceil(states.viewdetails.length / 4), (columnIndex + 1) * Math.ceil(states.viewdetails.length / 4))
          .map((i) => (
            <FormControlLabel
              key={i.screen_id}
              control={
                <Checkbox
                  color="primary"
                  checked={i.screen_is_active}
                  onChange={(e) => {
                    const updatedDetails = [...states.viewdetails];
                    const index = updatedDetails.findIndex(k => k.screen_id === i.screen_id);
                    if (index !== -1) {
                      updatedDetails[index].screen_is_active = e.target.checked;
                    }
                    let editArray =[...(edittedData.screenEdited ||[]),{screen_is_active:e.target.checked,screen_id:i.screen_id,screen_name:i.screen_name}]
                    setStates({
                      ...states,
                      viewdetails: updatedDetails,
                      edittedData: { ...edittedData, screenEdited: editArray },
                    });
                  }}
                />
              }
              className={classes.formControlLabel}
              label={i.screen_name}
              disabled={!isEdit}
            />
          ))}
        </Grid>
      ))}
    </Grid>         
          {/* <Grid item xs={2}>
            <FormGroup>{
              states?.viewdetails?.slice(0,10).map(i => {
                return <FormControlLabel
                  key={i.screen_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.screen_is_active}
                      onChange={(e) => {
                        let arr = [...states?.viewdetails];
                        let index = arr.findIndex(k => k.screen_id == i.screen_id);
                        console.log(i.screen_id,e.target.checked,'e.target.checked')
                        if (e.target.checked) {
                          arr[index].screen_is_active = true
                        } else {
                          arr[index].screen_is_active = false
                        }
                        setStates({ ...states,viewdetails: arr , edittedData: {
                          ...edittedData,
                          screenEdited: arr,
                        },})
                      }}
                    />
                  }
                  label={i.screen_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup>
          </Grid> */}
          {/* <Grid item xs={2}>
            <FormGroup>{
              states?.viewdetails?.slice(10,20).map(i => {
                return <FormControlLabel
                  key={i.screen_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.screen_is_active}
                      onChange={(e) => {
                        let arr = [...states?.viewdetails];
                        let index = arr.findIndex(k => k.screen_id == i.screen_id);
                        console.log(i.screen_id,e.target.checked,'e.target.checked')
                        if (e.target.checked) {
                          arr[index].screen_is_active = true
                        } else {
                          arr[index].screen_is_active = false
                        }
                        setStates({ ...states,viewdetails: arr , edittedData: {
                          ...edittedData,
                          screenEdited: arr,
                        },})
                      }}
                    />
                  }
                  label={i.screen_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup>
          </Grid> */}
          {/* <Grid item xs={2}>
            <FormGroup>{
              states?.viewdetails?.slice(20,30).map(i => {
                return <FormControlLabel
                  key={i.screen_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.screen_is_active}
                      onChange={(e) => {
                        let arr = [...states?.viewdetails];
                        let index = arr.findIndex(k => k.screen_id == i.screen_id);
                        console.log(i.screen_id,e.target.checked,'e.target.checked')
                        if (e.target.checked) {
                          arr[index].screen_is_active = true
                        } else {
                          arr[index].screen_is_active = false
                        }
                        setStates({ ...states,viewdetails: arr , edittedData: {
                          ...edittedData,
                          screenEdited: arr,
                        },})
                      }}
                    />
                  }
                  label={i.screen_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup>
          </Grid> */}
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {
            isEdit && (
              <Fragment>
                <Button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setDataObj(data);
                    setStates({ isEdit: false, edittedData: {} });
                  }}
                >
                  {'Cancel'}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    setStates({ loading: true });
                    handleUpdateScreen();
                  }}
                  disabled={loading}
                >
                  {'Update'}
                </Button>
              </Fragment>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
